/**
 * ★ 2026-11-04 웹·AOS 웹뷰 애플 로그인 (Sign in with Apple, 웹 리다이렉트 방식).
 *  iOS 앱은 지금처럼 네이티브 시트(nativeBridge.appleLogin)를 쓴다 — 이 파일은 iOS 앱이 아닐 때만.
 *
 *  흐름: 버튼 → appleAuthorizeUrl() 로 이동 → 애플 인증 → /appleAuth#id_token=…&state=… 로 돌아옴
 *        → 백엔드 POST /auth/apple { identityToken } (iOS 와 같은 검증, audience 에 Services ID 포함) → 자체 JWT.
 *  - response_mode=fragment 는 scope(이름·이메일)를 요청하지 않을 때만 허용된다. 이름은 가입 추가정보 단계에서 받는다.
 *  - client_id = Apple Developer 의 Services ID(REACT_APP_APPLE_SERVICES_ID). 없으면 버튼을 숨긴다.
 *  - Return URL(https://muyeon.co.kr/appleAuth)이 그 Services ID 에 등록돼 있어야 한다.
 */
export const APPLE_SERVICES_ID = process.env.REACT_APP_APPLE_SERVICES_ID || "";
export const APPLE_REDIRECT_PATH = "/appleAuth";
const STATE_KEY = "muyeon.appleState";

export const appleWebLoginEnabled = () => !!APPLE_SERVICES_ID;
export const appleRedirectUri = () => window.location.origin + APPLE_REDIRECT_PATH;

/** 애플 인증 페이지 URL. redirect = 로그인 후 돌아갈 경로. */
export const appleAuthorizeUrl = (redirect) => {
  const nonce = Math.random().toString(36).slice(2) + Date.now().toString(36);
  try { sessionStorage.setItem(STATE_KEY, JSON.stringify({ nonce, redirect: redirect || "" })); } catch { /* 저장 못 하면 콜백에서 거절 */ }
  const params = new URLSearchParams({
    client_id: APPLE_SERVICES_ID,
    redirect_uri: appleRedirectUri(),
    response_type: "code id_token",
    response_mode: "fragment",
    state: nonce,
  });
  return `https://appleid.apple.com/auth/authorize?${params.toString()}`;
};

/** 콜백의 state 가 우리가 보낸 값인지 확인 → 맞으면 돌아갈 경로, 아니면 null. 한 번 쓰면 지운다. */
export const consumeAppleState = (state) => {
  let saved = null;
  try {
    saved = JSON.parse(sessionStorage.getItem(STATE_KEY) || "null");
    sessionStorage.removeItem(STATE_KEY);
  } catch { /* 없음 */ }
  if (!saved || !state || saved.nonce !== state) return null;
  return saved.redirect || "/home";
};
